module.exports = __webpack_public_path__ + "img/kerala.d7dad948.png";